import React from 'react';
import styled from 'styled-components';
import home from '../../../assets/images/home.svg';
import privacy from '../../../assets/images/privacy.svg';
import dollar from '../../../assets/images/dollar.svg';
import wifi from '../../../assets/images/wifi.svg';
import char1 from '../../../assets/images/character zoi.svg';
import Container from '../../shared/Container';
import FlexContent from '../../shared/FlexContent';
import Heading from '../../shared/Heading';
import Image from '../../shared/Image';

const FeatureGrid = styled.div`
  display: flex;
  max-width: 700px;
  justify-content: space-between;
  flex-wrap: wrap;
  @media (max-width: 1000px) {
    max-width: initial;
    flex-direction: column;
    align-self: flex-start;
  }
`;

const IconCard = styled.div`
  display: flex;
  align-items: center;
  margin-right: 15px;
  margin-bottom: 70px;
  width: 300px;

  @media (max-width: 1000px) {
    margin-bottom: 40px;
  }
`;
const Icon = styled.div`
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);
  height: 50px;
  width: 50px;
  padding: 15px;
  margin-right: 20px;
  background-color: white;
  border-radius: 50%;
  display: inline-block;
  flex: 0 0 auto;
  img {
    width: 50px;
  }
  @media (max-width: 425px) {
    width: 30px;
    height: 30px;
    img {
      width: 30px;
    }
  }
`;
const IconText = styled.p`
  display: block;
  font-family: 'gothambold';
  margin: 0;
  padding: 0;
  color: white;
  font-size: 20px;
  z-index: 1;
  @media (max-width: 1367px) {
    font-size: 19px;
  }
  @media (max-width: 425px) {
    font-size: 16px;
  }
`;

const ImageWhy = styled(Image)`
  @media (max-width: 1000px) {
    position: absolute;
    right: 0;
    bottom: -5px;
    min-width: initial;
    width: 300px;
    max-width: initial;
    height: initial;
    img {
      width: 100%;
    }
  }
  @media (max-width: 600px) {
    right: -50px;
    bottom: 50px;
    width: 200px;
  }
  @media (max-width: 425px) {
    right: -100px;
    bottom: 50px;
    width: 180px;
  }
  @media (max-width: 300px) {
    display: none;
  }
`;

const FlexContentWhy = styled(FlexContent)`
  position: relative;
  @media (max-width: 1000px) {
    align-items: stretch;
  }
`;

const Feature = (props) => {
  const { icon, children } = props;
  return (
    <IconCard>
      <Icon>
        <img src={icon} alt="Icon Text" />
      </Icon>
      <IconText>{children}</IconText>
    </IconCard>
  );
};
const ContainerWhy = styled(Container)`
  padding-top: 50px;
  @media (max-width: 1000px) {
    padding-top: 30px;
  }
  @media (max-width: 425px) {
    padding-top: 0;
  }
  ${Heading} {
    text-align: left;
  }
`;
const Why = () => (
  <ContainerWhy>
    <Heading>Why choose Zoi Homes?</Heading>
    <FlexContentWhy>
      <div>
        <FeatureGrid>
          <Feature icon={home}>
            Fully <br /> Furnished <br /> Homes
          </Feature>
          <Feature icon={privacy}>
            Safe, Secure <br />& Diverse <br />
            Community
          </Feature>
          <Feature icon={dollar}>
            No Brokerage <br />& Affordable
            <br /> Rent
          </Feature>
          <Feature icon={wifi}>
            Wi-Fi
            <br /> & Other
            <br /> Amenities
          </Feature>
        </FeatureGrid>
      </div>
      <ImageWhy>
        <img src={char1} alt="Character" />
      </ImageWhy>
    </FlexContentWhy>
  </ContainerWhy>
);

export default Why;
